export default __webpack_public_path__ + "static/media/title.990a8ac3.png";